import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
import { FlightStopKind } from 'core/api';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class FlightDetailsComponent extends Vue {
    @Prop()
    flight: flights.FlightModel;

    @Prop()
    passengerCount: number;

    @Prop()
    submitLabel: string;

    @Prop()
    searchId?: string;

    @Prop({ default: true })
    canGoBack: boolean;

    getBaggageLabel(flightBaggage: api.FlightBaggage, isCabin: boolean): string {
        let label = utils.Baggage.getLabel(flightBaggage, isCabin);

        if (label == i18next.t('label_baggage_without')) {
            label = i18next.t('label_baggage_without_short');
        }
        if (label == i18next.t('label_baggage_cabin_without')) {
            label = i18next.t('label_baggage_cabin_without_short');
        }

        return label;
    }

    hasBaggage(legOrSegment: flights.LegModel | flights.SegmentModel): boolean {
        return legOrSegment.baggage && (legOrSegment.baggage.pieceWeight > 0 || legOrSegment.baggage.pieces > 0);
    }

    hasBaggageCabin(legOrSegment: flights.LegModel | flights.SegmentModel): boolean {
        return legOrSegment.baggageCabin && (legOrSegment.baggageCabin.pieceWeight > 0 || legOrSegment.baggageCabin.pieces > 0);
    }

    getStopLabel(stop: flights.SegmentStopModel, stopIndex: number, stopsCount: number): string {
        return stop.destination.iataCode + ((stopsCount > 1 && stopIndex < stopsCount - 1) ? ',' : '');
    }

    markerOwner() {
        return utils.Cookies.getMarkerOwner();
    }

    show() {
        (<any>this.$refs).modalFlight.show();
    }

    hide() {
        (<any>this.$refs).modalFlight.hide();
    }

    onFlightKind() {
        const flightKind = this.flight.flightKind == 'RegularSpecial' ? 'regularspecial' : this.flight.flightKind.toLowerCase();
        (<any>this.$refs).textContentFlightKind.show(
            'flight.kind.' + flightKind,
            i18next.t('label_flight_kind_' + flightKind)
        );
    }

    onSubmit() {
        this.$emit('submit', (<any>this.$refs).modalFlight);
    }

    onFlightTerms() {
        this.$emit('terms', this.flight);
    }

    onGoBack() {
        this.$emit('back', (<any>this.$refs).modalFlight);
    }

    onShow() {
        this.$emit('show', (<any>this.$refs).modalFlight);

        if (this.searchId) {
            new api.RetailRocket().flightDetailsOpened({
                flightId: this.flight.uniqueId,
                searchId: this.searchId
            });
        }
    }

    onHide() {
        this.$emit('hide', (<any>this.$refs).modalFlight);
    }

    onDismiss() {
        this.$emit('dismiss', (<any>this.$refs).modalFlight);
    }

    onStopClick(segment: flights.SegmentModel) {
        if (segment.nextSegmentStop == FlightStopKind.ByPassenger) {
            (<any>this.$refs).textContentFlightKind.show('flight.stopKind.byPassenger', i18next.t('label_flight_stop_self_tranfer'));
        }
    }
}
